import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  mainBoxImages: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '42px',
    paddingBottom: theme.spacing(3),
  },
}));
